import { enrich } from '@procuros/transformer';

import { logError } from 'services/logging/logging';
import { DocumentType } from 'support/types';

type EnrichmentMeta = Parameters<typeof enrich>[0]['meta'];

export const enrichDocument = <T>({
  data,
  messageType,
  meta,
}: {
  data: T;
  messageType?: DocumentType;
  meta?: EnrichmentMeta;
}): { data: T } => {
  if (!messageType) {
    return { data };
  }

  const enrichmentResult = enrich({
    input: data,
    documentType: messageType,
    meta,
  });

  if (!enrichmentResult.success) {
    logError(`Enrichment failed: ${enrichmentResult.error_message}`);
    return { data };
  }

  return { data: enrichmentResult.result };
};
